import { render, staticRenderFns } from "./Devolucao.vue?vue&type=template&id=e264c85c&scoped=true"
import script from "./Devolucao.vue?vue&type=script&lang=js"
export * from "./Devolucao.vue?vue&type=script&lang=js"
import style0 from "./Devolucao.vue?vue&type=style&index=0&id=e264c85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e264c85c",
  null
  
)

export default component.exports